import { type IHeaderParams } from '@ag-grid-community/core'
import { HeaderComp } from '@ag-grid-community/core/dist/esm/es6/headerRendering/cells/column/headerComp'
import { escapeString } from '@ag-grid-community/core/dist/esm/es6/utils/string'
import { atoms } from '../../../theme/atoms'

// @ts-ignore
export class SubHeaderRenderer extends HeaderComp {
  private currentDisplayName?: string
  private currentSubheader?: string
  private eText: HTMLElement | null = null

  setDisplayName(params: IHeaderParams<unknown, unknown>) {
    // @ts-ignore - bad typings
    const subHeader = params.subHeader as string

    if (
      this.currentDisplayName !== params.displayName ||
      this.currentSubheader !== subHeader
    ) {
      this.currentDisplayName = params.displayName
      this.currentSubheader = subHeader
      const displayNameSanitised = escapeString(
        this.currentDisplayName.replace(` (${this.currentSubheader})`, ''),
      )
      const subHeaderSanitiszed = escapeString(this.currentSubheader)

      if (this.eText) {
        if (this.eText.parentElement) {
          this.eText.parentElement?.classList.add(
            ...atoms({
              justifyContent: 'flexEnd',
            }).split(' '),
          )
        }
        this.eText.classList.add(
          ...atoms({
            display: 'flex',
            flexDirection: 'column',
            paddingRight: 'xs',
          }).split(' '),
        )

        const headerHtml = `<span class="${atoms({
          color: 'secondary',
        })}">${displayNameSanitised}</span><span class="${atoms({
          fontSize: 'xs',
          color: 'neutral',
          textAlign: 'right',
          fontWeight: '400',
        })}">${subHeaderSanitiszed}</span>`

        this.eText.innerHTML = headerHtml
      }
    }
  }
}
